var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ChipV2 as Chip } from "../../../Atoms";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
var HookChip = function (_a) {
    var icon = _a.icon, value = _a.value, label = _a.label, fieldName = _a.fieldName, selected = _a.selected, disabled = _a.disabled, tooltip = _a.tooltip, rest = __rest(_a, ["icon", "value", "label", "fieldName", "selected", "disabled", "tooltip"]);
    var setValue = useFormContext().setValue;
    var onClick = useCallback(function () {
        setValue(fieldName, value, {
            shouldDirty: true,
            shouldValidate: true,
        });
    }, []);
    return (_jsx(Chip, __assign({ icon: icon, size: "small", label: label, onClick: onClick, selected: selected, disabled: disabled, tooltip: tooltip }, rest)));
};
export default HookChip;
